/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { PageNotFound } from "../Utils/PageNotFound";
import { FileSearchPage } from "./FileSearchPage";
import { useDexterTheme } from "../DesignSystem/Theme/ThemeContext";

export function FilesIndex(): JSX.Element {
  const { currentTheme } = useDexterTheme();
  const match = useRouteMatch();

  return (
    <div
      style={{
        backgroundColor: currentTheme.colors.pageBackgroundColor,
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Switch>
        {/* Must be the last path element to prevent it from matching
                  descendent paths */}
        <Route exact path={match.path}>
          <FileSearchPage />
        </Route>
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </div>
  );
}
